module.exports = __webpack_public_path__ + "static/media/img-avatar-default.7eceb00f.png";